"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
var isEmail = function (value) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    return regex.test(value.trim());
};
exports.isEmail = isEmail;
//# sourceMappingURL=isEmail.js.map